import * as Yup from 'yup';
import addVisitorModel, { visitorTypeOptions } from './addVisitorModel';

const {
  formField: {
    firstName,
    lastName,
    visitorEmail,
    visitorWhatsApp,
    visitorType,
    purpose,
    visitDateTime,
    isMultiDay,
    startDate,
    endDate,
    propertyId,
    consent,
  }
} = addVisitorModel;

const CONTACT_REQUIRED_MSG = 'Provide either a visitor email or WhatsApp number';

// Must match the inDrive value in visitorTypeOptions
export const IN_DRIVE_VISITOR_TYPE = 'indrive';

const requiredUnlessInDrive = (message: string) => (schema: Yup.StringSchema) =>
  schema.when(visitorType.name, {
    is: IN_DRIVE_VISITOR_TYPE,
    then: (s) => s.notRequired(),
    otherwise: (s) => s.trim().required(message),
  });

const addVisitorSchema = {
  [firstName.name]: requiredUnlessInDrive(`${firstName.requiredErrorMsg}`)(Yup.string()),
  [lastName.name]: requiredUnlessInDrive(`${lastName.requiredErrorMsg}`)(Yup.string()),
  [visitorEmail.name]: Yup.string()
    .email(`${visitorEmail.invalidErrorMsg}`)
    .test('email-or-whatsapp', CONTACT_REQUIRED_MSG, function (value) {
      return Boolean(value) || Boolean(this.parent[visitorWhatsApp.name]);
    }),
  [visitorWhatsApp.name]: Yup.string()
    .test('email-or-whatsapp', CONTACT_REQUIRED_MSG, function (value) {
      return Boolean(value) || Boolean(this.parent[visitorEmail.name]);
    }),
  [visitorType.name]: Yup.string()
    .oneOf(visitorTypeOptions.map((option) => option.value))
    .required(visitorType.requiredErrorMsg),
  [purpose.name]: Yup.string()
    .trim()
    .when(visitorType.name, {
      is: 'other',
      then: (schema) => schema.required(purpose.requiredErrorMsg),
      otherwise: (schema) => schema.notRequired(),
    }),
  [isMultiDay.name]: Yup.boolean(),
  [visitDateTime.name]: Yup.date()
    .when(isMultiDay.name, {
      is: false,
      then: (schema) => schema.required(visitDateTime.requiredErrorMsg),
      otherwise: (schema) => schema.nullable(),
    }),
  [startDate.name]: Yup.date()
    .when(isMultiDay.name, {
      is: true,
      then: (schema) => schema.required(startDate.requiredErrorMsg),
      otherwise: (schema) => schema.nullable(),
    }),
  [endDate.name]: Yup.date()
    .when(isMultiDay.name, {
      is: true,
      then: (schema) => schema
        .required(endDate.requiredErrorMsg)
        .min(
          Yup.ref(startDate.name),
          'End date must be after start date'
        ),
      otherwise: (schema) => schema.nullable(),
    }),
  [propertyId.name]: Yup.string()
    .required(propertyId.requiredErrorMsg),
  [consent.name]: Yup.boolean()
    .oneOf([true], consent.requiredErrorMsg)
    .required(consent.requiredErrorMsg),
};

export default addVisitorSchema